<div *ngIf="keyValueMeshes">
  <div class="row">
    <h6 style="margin-bottom: 30px">
      <span style="color: #f49602">&#9679;</span>
      &nbsp; Please select a CAD geometry to simulate
    </h6>

    <div class="col-10">
      <usimweb-form-input
        placeholder="Add/Select CAD geometry "
        [value]="part.cadModel"
        [readonly]="true"
        [required]="true"
        [toolTipText]="cadToolTip"
      ></usimweb-form-input>
    </div>

    <div class="col-1">
      <usimweb-button-icon
        [icon]="'add'"
        fontColor="white"
        tooltip="Add/Select CAD geometry..."
        (btnClick)="openCadDetailDialog()"
      ></usimweb-button-icon>
    </div>
  </div>
</div>

<div *ngIf="part.volume > 0" style="margin-top: 25px">
  <usimweb-form-input
    placeholder="Gravity Vector (x, y, z)"
    [value]="gravityStr"
    [readonly]="true"
  ></usimweb-form-input>
  <usimweb-form-input
    placeholder="Volume [m³]"
    [value]="part.volume"
    [type]="inputType.FLOAT_NUMBER"
    (selectionChange)="part.volume = $event"
    [readonly]="true"
  ></usimweb-form-input>
</div>
